import { render, staticRenderFns } from "./MyEvaluationsPage.vue?vue&type=template&id=94ad1068"
import script from "./MyEvaluationsPage.vue?vue&type=script&lang=js"
export * from "./MyEvaluationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports